<template>
  <div id="dc_mypage">
    <dd-header />
    <div class="wrapper">
      <h1 style="display:none;">マイページ</h1>
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>アカウント管理</h2>
            <div class="mypage_list">
              <div>
                <a @click="route('DcOrderHistoryList')">ご注文履歴</a>
              </div>
              <div>
                <a @click="route('DcUserAccount')">アカウント情報</a>
              </div>
              <!-- <div>
                <a @click="route('DcDeliveryList')">登録納品先の管理</a>
              </div> -->
            </div>
          </section>
          <section v-if="isCorpLogin">
            <h2>所属企業の管理</h2>
            <div class="mypage_list">
              <div>
                <a @click="route('DcUserManager')">ユーザ管理</a>
              </div>
            </div>
          </section>
          <section>
            <div class="control_btn_area">
              <div class="detail_btn5" @click="logout()">ログアウト</div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcMyPage',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'}
      ],
      user: {}
    }
  },
  computed: {
    isCorpLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userType !== 'DC_ADMIN') return false
      if (this.user.userLevel === 2) return true
      if (this.user.userLevel === 1) return true
      return false
    }
  },
  methods: {
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    logout: function () {
      axios.post(DC_URL.TOP + '/logout', {}
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.USER_INFO)
          App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
          App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
          App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
          // this.$nextTick(function () {
          //   this.user = undefined
          //   this.$forceUpdate()
          // })
          AppEc.showModal({
            messages: ['ログアウトしました。'],
            onOk: (callback) => {
              this.$router.push({
                name: 'DcTop'
              })
            }
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcMyPage.vue